import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Snackbar,
  Container,
  Typography,
  FormControlLabel,
  Checkbox,
  Box,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { collection, addDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import TBAdminTopNav from "./TBAdminTopNav";

const AddDashboard = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [url, setUrl] = useState("");
  const [isFavorite, setIsFavorite] = useState(false);
  const [selectedOrgId, setSelectedOrgId] = useState("");
  const [organizations, setOrganizations] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const snapshot = await getDocs(collection(db, "organizations"));
        const orgList = snapshot.docs.map((doc) => ({
          id: doc.id,
          name: doc.data().name,
        }));
        setOrganizations(orgList);
      } catch (error) {
        console.error("Error fetching organizations:", error);
      }
    };

    fetchOrganizations();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedOrgId || !title || !category || !url) {
      setSnackbar({ open: true, message: "Please fill in all fields." });
      return;
    }

    try {
      await addDoc(collection(db, "dashboards"), {
        title,
        category,
        url,
        isFavorite,
        organizationId: selectedOrgId,
      });

      setSnackbar({ open: true, message: "Dashboard added successfully!" });
      setTitle("");
      setCategory("");
      setUrl("");
      setIsFavorite(false);
      setSelectedOrgId("");
    } catch (error) {
      console.error("Error adding dashboard:", error);
      setSnackbar({ open: true, message: "Failed to add dashboard." });
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <TBAdminTopNav />
      <Typography variant="h5" gutterBottom>
        Add New Dashboard
      </Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>Select Organization</InputLabel>
          <Select
            value={selectedOrgId}
            onChange={(e) => setSelectedOrgId(e.target.value)}
            required
          >
            {organizations.map((org) => (
              <MenuItem key={org.id} value={org.id}>
                {org.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Title"
          fullWidth
          margin="normal"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          label="Category"
          fullWidth
          margin="normal"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
        <TextField
          label="Dashboard URL"
          fullWidth
          margin="normal"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isFavorite}
                onChange={(e) => setIsFavorite(e.target.checked)}
              />
            }
            label="Mark as Favorite"
          />
        </Box>
        <Box mt={2}>
          <Button type="submit" variant="contained" color="primary">
            Add Dashboard
          </Button>
        </Box>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />
    </Container>
  );
};

export default AddDashboard;
